import { render, staticRenderFns } from "./reporting.vue?vue&type=template&id=0c58a8b2&"
import script from "./reporting.vue?vue&type=script&lang=ts&"
export * from "./reporting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports